import { Navigate, NavLink, useParams } from "react-router";
import { useFondByIdQuery, useUpdateFondMutation } from "../../stores/OkOkStore";
import UsersSelector from "../../components/Users/UsersSelector";
import { type RefUser,roles } from "../../types/Users";
import { useState, useEffect } from "react";
import { useTrads } from "../../contexts/trads/useTrads";
import type { FondUpdate } from "../../types/Fond";
function ManagerFondBeneficiaires(){
    const params = useParams();
    const { data, error, isLoading } = useFondByIdQuery(params.fondId??"0");
     const [updateFond,result]=useUpdateFondMutation();
    const [users, setUsers] = useState<RefUser[]>([]);
    const {translate}=useTrads();
    const submitHandler=function(){
        if(data){
            const x:FondUpdate={id:data.id,beneficiaires:users};
            void updateFond(x);
        }
    }

    useEffect(()=>{
        if(data?.beneficiaires){
            setUsers(data.beneficiaires);
        }
    },[data,setUsers]);
    return (

        result.isSuccess ? <Navigate to={`/fond/${result.data.id.toString()}`} state={{modified:"true"}}></Navigate>  :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :


            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <div>
                    <nav>
                        <ul  className="nav nav-tabs">
                            <li className="nav-item"><NavLink className="nav-link" to={`/fond/${data.id.toString()}/edit`}>{translate('btn_fond_edit')}</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to={`/fond/${data.id.toString()}/operators`}>{translate('btn_fond_edit_operators')}</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to={`/fond/${data.id.toString()}/beneficiaires`}>{translate('btn_fond_edit_beneficiaires')}</NavLink></li>
                        </ul>
                    </nav>


                    <UsersSelector users={users} clickHandler={setUsers} filtre={{"r[rangacces]":roles.Beneficiaires}}></UsersSelector>
                    
                    <button onClick={submitHandler}>{translate('btn_save')}</button>
                </div>
            ):null
        )
    );

}
export default ManagerFondBeneficiaires;